import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions";
import { css } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import Search from "@insite/mobius/Icons/Search";

Object.assign(myListsDetailsOptionsStyles, {
    rightColumnWrapper: {
        css: css`
            display: flex;
            width: 40px;
            justify-content: center;
            margin-top: 33px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin-top: 28px;
                        `,
                    ],
                    "max",
            )}
            button[data-test-selector^="popoverOverflowTrigger"] {
                min-width: 1px;
            }
        `,
    },
    selectAll: {
        css: css`
            cursor: pointer;
            span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) {
                background: #fff;
                border: 1px solid #bebdbd;
                color: #19a3e0;
            }
            span[role="checkbox"]:focus {
                outline: none;
                box-shadow: 0 0 0 1px #e2e3e6;
            }
        `,
    },
    editSortOrder: {
        css: css`
            cursor: pointer;
            margin-left: 30px;
            span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) {
                background: #fff;
                border: 1px solid #bebdbd;
                color: #19a3e0;
            }
            span[role="checkbox"]:focus {
                outline: none;
                box-shadow: 0 0 0 1px #e2e3e6;
            }
        `,
    },
    productSelectorGridItem: {
        width: [12, 12, 12, 10, 10],
        css: css`
            justify-content: center;
        `,
    },
    uploadItemsGridItem: {
        width: [12, 12, 12, 2, 2],
        css: css`
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        padding-top: 30px;
                        justify-content: center;
                    `,
                    css`
                        padding-top: 30px;
                        justify-content: center;
                    `,
                ])}
        `,
    },
    uploadItemsModal: {
        sizeVariant: "large",
        // size: 16,
        cssOverrides: {
            modalTitle: css`
                padding: 10px 30px;
            `,
            modalContent: css`
                padding: 20px 30px;
            `,
        },
    },
    search: {
        iconProps: {
            src: Search,
            css: css`
                background: ${COLORS.white};
                position: absolute;
                box-sizing: border-box;
                top: 2px;
                right: 2px;
                width: 36px;
                height: 36px;
                padding: 8px;
                border-radius: 100%;
                pointer-events: none;
            `,
        },
    },
});
